import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import './index.css'
import { Container, Row, Col } from 'reactstrap';



class FormResponse extends PureComponent {
  
    constructor(props) {
        super(props);
        this.state = {
            forms:[],
            form_slug:props.match.params.slug,
            labels:[],
            responses:[],
            form_title:'',
            loading:true,
            page:1,
            total_pages:0,


        };
        this.downloadFormResponse = this.downloadFormResponse.bind(this);
        this.onScroll = this.onScroll.bind(this);
    
    }


     componentDidMount() {
        this.getFormResponse();
        window.addEventListener('scroll', this.onScroll, false); 
    }
    onScroll(){
        if(this.state.total_pages>1)
        {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&!this.state.loading){
                if(this.state.total_pages>this.state.page){
                    this.setState({page:(this.state.page+1)},()=>{
                        this.getFormResponse();
                    })
                }
            }
        }
    }
    downloadFormResponse(){
        const url = `${getLocationOrigin()}/form/download_form_responses/?slug=${this.state.form_slug}`;
        window.open(url);
    }
       
    getFormResponse() {
         const url = `${getLocationOrigin()}/form/get_form_responses/?slug=${this.state.form_slug}&page=${this.state.page}`;
         const options = {...defaultOptions};

         fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data =>{
                    var responses = Object.assign([], this.state.responses);
                    responses = [...responses,...data.result.responses]
                    this.setState({ responses:responses,labels:data.result.labels, form_title:data.result.form_title ,loading:false,total_pages:data.result.num_pages})
                })
           .catch(error => error);
    }

    render() {
        return(
            <div className="response_root">
                {this.state.loading?
                    <div className="form_response_loader">Loading...</div>
                :
                    <div className="form_response_root">
                        <div className="form_response_display">
                            <div className="form_response_download" style={{}}>
                                <div className="form_response_form_title">{this.state.form_title}</div>
                                <div className="form_response_download_btn" onClick={()=>{this.downloadFormResponse()}} >Download</div>
                            </div>
                            {this.state.responses && this.state.responses.length>0 ?
                                <div className="form_response_table">
                                    <Row  md='12' className="form_response_label_row">
                                        <Col md='2' className="form_response_label">
                                            <div className="form_response_label_text" style={{width:'48px'}}>Sl.No</div>
                                        </Col>
                                        {this.state.labels &&  this.state.labels.map((label,key)=>(
                                            <Col md='2' className="form_response_label">
                                                <div className="form_response_label_text">{label.length<50?label:label.slice(0,40)+'...'}</div>
                                            </Col>
                                        ))}
                                    </Row>
                                    <div className="form_response_table_content">
                                        {this.state.responses &&this.state.responses.map((response,index)=>{
                                            return(
                                                <Row md='12' className="form_response_data_row">
                                                    <Col md='2' className="response_answer" >
                                                        <div className="response_answer_text" style={{width:'50px'}}>{index+1}</div>
                                                    </Col>
                                                    {this.state.labels &&  this.state.labels.map((label,label_index)=>{
                                                        let answer ="-------"
                                                        let field = response.filter(info=>info.label==label)
                                                        if(field && field.length>0)
                                                            answer = field[0].answer
                                                        return(
                                                            <Col md='2' className="response_answer">
                                                                {answer && answer.includes('/media/form/')?
                                                                    <a className="response_answer_text" href={answer}>{answer}</a>
                                                                :
                                                                    <div className="response_answer_text">{answer?answer:'-----'}</div>
                                                                }
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            )
                                        })}
                                    </div>
                                </div>
                            :
                                <div className="no_form_response">No form submissions yet</div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default FormResponse;





// WEBPACK FOOTER //
// ./src/app/views/partner/crud/form/response.js